export async function getCityFromGPS() {
    if (!navigator.geolocation) {
        console.warn('Geolocation is not supported by this browser.');
        return '';
    }
    return new Promise((resolve) => {
        navigator.geolocation.getCurrentPosition(async (position) => {
            try {
                const { latitude, longitude } = position.coords;
                // Use OpenStreetMap Nominatim for free reverse geocoding
                const response = await fetch(`https://nominatim.openstreetmap.org/reverse?format=json&lat=${latitude}&lon=${longitude}&zoom=10&addressdetails=1`);
                if (!response.ok) {
                    resolve('');
                    return;
                }
                const data = await response.json();
                // Nominatim returns various fields depending on the location
                const city = data.address?.city || data.address?.town || data.address?.village || data.address?.county || '';
                resolve(city);
            }
            catch (e) {
                console.warn('Error during reverse geocoding', e);
                resolve('');
            }
        }, (error) => {
            console.warn('Geolocation error or permission denied:', error.message);
            resolve('');
        }, {
            timeout: 10000,
            maximumAge: 60000 // Cache location for 1 minute
        });
    });
}
